import { api } from './api';

export interface PricingInfo {
  fee: number;
  tax: number;
  total: number;
}

export const getPricingInfo = async ({
  price,
  zipCode,
  restaurantId,
  isInitialPurchase,
}: {
  price: number;
  zipCode: string;
  restaurantId?: string;
  /** A restaurant can pay the fee of an initial purchase, but not of a resale or an offer. */
  isInitialPurchase?: boolean;
}) => {
  const restaurantQuery = restaurantId ? `&restaurantId=${restaurantId}` : '';
  const initialPurchaseQuery = isInitialPurchase
    ? '&isInitialPurchase=true'
    : '';

  return api.get<PricingInfo>(
    `/pricing-info?price=${price}&zipCode=${zipCode}${restaurantQuery}${initialPurchaseQuery}`,
  );
};
